import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import * as actionCreators from "../../actions/user";
import history from "../../history";

import { List, ListItem } from "material-ui/List";
import Avatar from "material-ui/Avatar";
import { AppBar } from "@material-ui/core";
// import Drawer from '@material-ui/core/Drawer';
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";

// import Drawer from "material-ui/Drawer";
import BookIcon from "@material-ui/icons/Book";
import MenuItem from "material-ui/MenuItem";
import IconNewApp from "material-ui/svg-icons/content/add-box";
import IconViewApps from "material-ui/svg-icons/action/assignment";
import IconLogout from "material-ui/svg-icons/action/input";
import IconOrganization from "material-ui/svg-icons/communication/business";
import SocialPerson from "material-ui/svg-icons/social/person";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";

import NormalFlatButton from "../../components/common/NormalFlatButton";
import InfoChip from "../../components/common/InfoChip";

import colors from "../../styles/colors";
import { colorsV2 } from "../../styles/colors";

const style = {
  container: {
    display: "flex",
    flexFlow: "column",
    minWidth: "100%",
    minHeight: 20,
  },
  header: {
    backgroundColor: colorsV2.primary,
    minWidth: "100%",
    display: "flex",
    textAlign: "left",
  },
  list: {
    backgroundColor: colorsV2.primary,
    height: "100%",
    //paddingTop: 42,
  },
  link: {
    textDecoration: "none",
  },
  item: {
    left: "auto",
    marginBottom: 30,
  },
  icon: {
    marginRight: 12,
  },
  text: {
    display: "inline-block",
    color: "white",
    fontSize: 18,
  },
  footer: {
    position: "fixed",
    bottom: 60,
    width: 246,
    display: "flex",
    flexFlow: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  avatar: {
    margin: 5,
  },
};

class SideNavMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isProvider: false,
      open: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.userInfo) {
      this.setState({ isProvider: nextProps.userInfo.isProvider });
    }
  }

  render() {
    if (this.props.targetDevice === "mobile") {
      return (
        <div style={style.container}>
          <AppBar position="static">
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                aria-label="menu"
                onClick={() => this.setState({ open: !this.state.open })}
              >
                <MenuIcon />
              </IconButton>
              <Typography variant="h6" style={style.header}>
                {this.props.title}
              </Typography>
            </Toolbar>
          </AppBar>
          <SwipeableDrawer
            open={this.state.open}
            onClose={() => this.setState({ open: false })}
          >
            <div style={style.list}>
              <List>
                {this.state.isProvider && (
                  <Link to="/create-app" style={style.link}>
                    <MenuItem>
                      <IconNewApp style={style.icon} color="white" />
                      <div style={style.text}>Create New Channel</div>
                    </MenuItem>
                  </Link>
                )}

                <Link to="/view-channels" style={style.link} className={"step_5"}>
                  <MenuItem>
                    <IconViewApps style={style.icon} color="white" />
                    <div style={style.text}>View My Channels ZZ</div>
                  </MenuItem>
                </Link>
                <Link
                  to={`/external-resources/${this.props.userId}`}
                  style={style.link}
                  className={"step_6"}
                >
                  <ListItem style={style.item}>
                    <BookIcon style={style.icon} />
                    <div style={style.text}>External resources</div>
                  </ListItem>
                </Link>
                <Link to={`/profile/${this.props.userId}`} style={style.link} className={"step_7"}>
                  <MenuItem>
                    <SocialPerson style={style.icon} color="white" />
                    <div style={style.text}>My Profile</div>
                  </MenuItem>
                </Link>
              </List>
              <div style={style.footer}>
                {this.props.userProfile && (
                  <Avatar
                    style={style.avatar}
                    src={this.props.userProfile.picture}
                    size={96}
                  />
                )}
                {this.props.userInfo.hasOrg && (
                  <Link
                    to={`/view-organization-details/${this.props.userInfo.orgId}`}
                    style={style.link}
                  >
                    <InfoChip
                      icon={<IconOrganization />}
                      label="Organization"
                      color={colors.accent}
                      onClick={() => {}}
                    />
                  </Link>
                )}
                <br />
                <NormalFlatButton
                  icon={<IconLogout />}
                  style={{ color: "white" }}
                  label="Log Out"
                  onClick={() => {
                    this.props.userLogOut(-1);
                    history.replace("/");
                  }}
                />
              </div>
            </div>
          </SwipeableDrawer>
        </div>
      );
    } //end if
    else return <div></div>;
  } //end render
}

function mapStateToProps({ user, message, apps }) {
  return {
    user,
    userId: user.userId,
    userProfile: user.profile,
    userInfo: user.userInfo,
    notifications: message.notifications,
    apps,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SideNavMobile);



// WEBPACK FOOTER //
// ./src/layout/navigation/SideNavMobile.js